<template>
  <div class="payment-create main-content">
    <form action="" @submit.prevent="submitPaymentData">
      <div class="page-header">
        <h3 class="page-title">{{ $t('prepayments.invoice_payment_request') }}</h3>
        <ol class="breadcrumb">

          <li class="breadcrumb-item">
            <router-link slot="item-title" to="/funder/dashboard" >{{ $t('general.home') }}</router-link>
          </li>
          <li class="breadcrumb-item">

            <router-link v-if="$route.name === 'preapproved.invoice.pending'" slot="item-title" to="/funder/preapproved-invoices" >{{ $tc('preapproved_invoices.invoice', 2) }}</router-link>
            <router-link v-else slot="item-title" to="/funder/invoices" >{{ $tc('invoices.invoice', 2) }}</router-link>

          </li>
          <li class="breadcrumb-item">{{ $t('prepayments.invoice_payment_request') }}</li>
        </ol>
        <div class="page-actions row">
          <div class="col-xs-2 mr-4">
            <base-button
              v-if="isRejectedButtonShow"
              :outline="true"
              size="large"
              icon="times"
              color="theme"
              @click="rejectedPrepaymentRequest()"
            >
              {{ $t('general.reject') }}
            </base-button>
          </div>
          <div class="col-xs-2">
            <base-button
              v-if="isOfferButtonShow"
              :loading="isLoading"
              :disabled="isLoading"
              size="large"
              icon="save"
              color="theme"
              type="submit"
            >
              {{ $t('general.offer') }}
            </base-button>
          </div>
        </div>
      </div>
      <SinglePreapprovedInvoiceRow v-if="$route.name === 'preapproved.invoice.pending'" :fetch-data="fetchData" />
      <SingleInvoiceRow v-else :fetch-data="fetchData" />

      <div class="payment-card card">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label">{{ $t('prepayments.date') }}</label><span class="text-danger"> *</span>
                <base-date-picker
                  v-model="formData.payment_date"
                  :calendar-button="true"
                  :disabled="true"
                  calendar-button-icon="calendar"
                />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label">{{ $t('general.promised_payment_date') }}</label><span class="text-danger"> *</span>

                <base-date-picker
                  v-model="formData.promised_payment_date"
                  :calendar-button="true"
                  :disabled="true"
                  calendar-button-icon="calendar"
                />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label">{{ $t('prepayments.prepayment_request_number') }}</label><span class="text-danger"> *</span>
                <div class="base-read-box base-read-box-field">
                  <span v-html="requestNumber"/>
                </div>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label" >{{ $t('prepayments.offer_requested_on_date') }}</label>
                <div class="base-read-box base-read-box-field">
                  <span v-if="formData.supplier_offer_request && formData.supplier_offer_request=='as_soon_as_possible' " v-html="'As Soon as Possible'"/>
                  <span v-else-if="formData.supplier_offer_request && formData.supplier_offer_request=='select_a_date'" v-html="formData.formattedSupplierOfferRequestDate"/>
                </div>
              </div>
            </div>
            <!-- <div class="col-sm-6">
                <div class="form-group" @click="cashFlowModel()">
                    <label class="form-label">{{ $t('general.cashflow_value') }}</label><span class="text-danger"> *</span>
                    <div class="base-read-box base-read-box-field">
                        <div v-html="$utils.formatMoney(cashflowValue, customerCurrency)" />
                    </div>
                </div>
            </div> -->

            <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label">{{ $t('general.loanable_amount') }}</label><span class="text-danger"> *</span>
                <div class="base-input">
                  <money
                    :disabled="'true'"
                    v-model="LoanableAmount"
                    v-bind="customerCurrencyMoneyFormat"
                    class="input-field"
                  />
                </div>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label">{{ $t('general.discount') }}</label><span class="text-danger"> *</span>
                <div class="base-input">
                  <money
                    :disabled="'true'"
                    v-model="discount"
                    v-bind="customerCurrencyMoneyFormat"
                    class="input-field"
                  />
                </div>
              </div>
            </div>

            <div v-show="false" class="col-sm-6">
              <div class="form-group">
                <label class="form-label">{{ $t('general.funder_fees') }}</label><span class="text-danger"> *</span>
                <div class="base-input">
                  <money
                    :disabled="'true'"
                    v-model="funderAmount"
                    v-bind="customerCurrencyMoneyFormat"
                    class="input-field"
                  />
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label">{{ $t('general.transaction_fees') }}</label><span class="text-danger"> *</span>
                <div class="base-input">
                  <money
                    :disabled="'true'"
                    v-model="adminAmount"
                    v-bind="customerCurrencyMoneyFormat"
                    class="input-field"
                  />
                </div>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label">{{ $t('general.request_amount') }}</label><span class="text-danger"> *</span>
                <div class="base-read-box base-read-box-field">
                  <div v-html="$utils.formatMoney(formData.requested_amount, customerCurrency)" />
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group" @click="offerAmountModel()">
                <label class="form-label">{{ $t('general.offer_amount') }}</label><span class="text-danger"> *</span>
                <div class="base-input">
                  <money
                    :disabled="'true'"
                    v-model="amount"
                    v-bind="customerCurrencyMoneyFormat"
                    class="input-field"
                  />
                </div>
                <div v-if="$v.formData.amount.$error">
                  <span v-if="!$v.formData.amount.required" class="text-danger">{{ $t('validation.required') }}</span>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label">{{ $t('prepayments.rate_of_pre_payment') }}</label><span class="text-danger"> *</span>
                <div class="base-input">
                  <money
                    :class="{'invalid' : $v.formData.rate_of_prepayment.$error}"
                    v-model="formData.rate_of_prepayment"
                    v-bind="percentageFormatMoneyComponent"
                    class="input-field"
                  />
                </div>
                <div v-if="$v.formData.rate_of_prepayment.$error">
                  <span v-if="!$v.formData.rate_of_prepayment.between" class="form-group__message text-danger">{{ $t('validation.enter_valid_tax_rate') }}</span>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label">{{ $t('general.financing_ratio') }}</label><span class="text-danger"> *</span>
                <div class="base-input">
                  <money
                    :class="{'invalid' : $v.formData.margin_rate.$error}"
                    v-model="formData.margin_rate"
                    v-bind="percentageFormatMoneyComponent"
                    class="input-field"
                  />
                </div>
                <div v-if="$v.formData.margin_rate.$error">
                  <span v-if="!$v.formData.margin_rate.required" class="text-danger">{{ $t('validation.required') }}</span>
                  <span v-if="!$v.formData.margin_rate.between" class="form-group__message text-danger">{{ $t('validation.enter_valid_tax_rate') }}</span>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label">{{ $t('prepayments.payment_mode') }}</label>
                <div class="base-read-box base-read-box-field">
                  <span v-if="formData.payment_method" v-html="formData.payment_method.name"/>
                  <span v-else v-html="'No Payment Mode Select'"/>
                </div>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label">{{ $t('prepayments.offer_expire') }}</label>
                <base-date-picker
                  v-model="formData.offer_expire"
                  :calendar-button="true"
                  :disabled="true"
                  :disabled-dates= "{
                    to: new Date(Date.now())
                  }"
                  calendar-button-icon="calendar"
                />
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label class="form-label">{{ $t('prepayments.supplier_comment') }}</label>
                <div class="base-read-box base-read-box-field">
                  <span v-if="formData.supplier_comment" v-html="formData.supplier_comment"/>
                  <span v-else v-html="'No Supplier Comment'"/>
                </div>

              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label class="form-label">{{ $t('prepayments.administrator_comment') }}</label>
                <div class="base-read-box base-read-box-field">
                  <span v-if="formData.superAdmin_comment" v-html="formData.superAdmin_comment"/>
                  <span v-else v-html="'No Administrator Comment'"/>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label class="form-label">{{ $t('prepayments.anchor_comment') }}</label>
                <div class="base-read-box base-read-box-field">
                  <span v-if="formData.anchor_comment" v-html="formData.anchor_comment"/>
                  <span v-else v-html="'No Administrator Comment'"/>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group collapse-button-container">
                <base-button
                  :loading="isLoading"
                  icon="save"
                  color="theme"
                  type="submit"
                  class="collapse-button"
                >
                  {{ $t('prepayments.save_prepayment') }}
                </base-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import SingleInvoiceRow from '../invoices/SingleInvoiceRow'
import SinglePreapprovedInvoiceRow from '../preapprovedInvoices/SingleInvoiceRow.vue'
import { mapActions, mapGetters } from 'vuex'
import MultiSelect from 'vue-multiselect'
import { validationMixin } from 'vuelidate'
import moment from 'moment'
import 'moment-timezone'
const { required, between } = require('vuelidate/lib/validators')

export default {
  components: { MultiSelect, SingleInvoiceRow, SinglePreapprovedInvoiceRow },
  mixins: [validationMixin],
  data () {
    return {

      customerCurrency: null,
      userType: null,
      formData: {
        withholding_tax_rate: 0,
        payment_number: null,
        payment_date: null,
        promised_payment_date: null,
        amount: 0,
        requested_amount: 0,
        payment_method: null,
        invoice_id: null,
        supplier_comment: null,
        superAdmin_comment: null,
        anchor_comment: null,
        user_id: null,
        user_company_id: null,
        customer_id: null,
        rate_of_prepayment: 0,
        margin_rate: 0,
        transaction_fees: 0,
        loanableAmount: 0,
        discount: 0,
        funderAmount: 0,
        adminAmount: 0,
        offer_expire: null,
        supplier_offer_request: null,
        formattedSupplierOfferRequestDate: null
      },
      isLoading: false,
      isOfferButtonShow: true,
      isRejectedButtonShow: true,
      fetchData: [],
      percentageFormat: {
        precision: 0,
        thousand_separator: ',',
        decimal_separator: '.',
        symbol: '% '
      },
      percentageFormatMoneyComponent: {
        decimal: '.',
        thousands: ',',
        prefix: '% ',
        precision: 2,
        masked: false
      },
      requestNumber: null,
      cashflowValue: 0,

      maxPayableAmount: Number.MAX_SAFE_INTEGER,
      nomial_amount: 0,
      tenor: 0,
      tenor_per_year: 0

    }
  },
  created () {
    if (localStorage.getItem('role') === 'super_admin') {
      this.userType = 'super_admin'
    } else if (localStorage.getItem('account_type') === 'anchor') {
      this.userType = 'anchor'
    } else if (localStorage.getItem('account_type') === 'supplier') {
      this.userType = 'supplier'
    } else if (localStorage.getItem('account_type') === 'funder') {
      this.userType = 'funder'
    }
    this.loadInvoice()
  },
  validations () {
    return {
      formData: {
        rate_of_prepayment: {
          between: between(0, 100)
        },
        margin_rate: {
          required,
          between: between(0, 100)
        },
        offer_expire: {
          required
        },
        amount: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters('currency', [
      'defaultCurrencyForInput'
    ]),
    ...mapGetters('payment', [
      'paymentModes'
    ]),
    customerCurrencyMoneyFormat () {
      if (this.customerCurrency) {
        return {
          decimal: this.customerCurrency.decimal_separator,
          thousands: this.customerCurrency.thousand_separator,
          prefix: this.customerCurrency.symbol + ' ',
          precision: this.customerCurrency.precision,
          masked: false
        }
      } else {
        return this.defaultCurrencyForInput
      }
    },
    amount: {
      get: function () {
        return (this.formData.funderAmount) - (this.formData.adminAmount)
      },
      set: function (newValue) {
        this.formData.amount = newValue
      }
    },
    LoanableAmount: {
      get: function () {
        return (this.cashflowValue) * (this.formData.margin_rate / 100)
      },
      set: function (newValue) {
        this.formData.loanableAmount = newValue
      }
    },
    discount: {
      get: function () {
        let loan = this.formData.loanableAmount
        return (this.formData.rate_of_prepayment / 100 * loan) * (this.tenor / 365)
      },
      set: function (newValue) {
        this.formData.discount = newValue
      }
    },
    funderAmount: {
      get: function () {
        return (this.formData.loanableAmount) - (this.formData.discount)
      },
      set: function (newValue) {
        this.formData.funderAmount = newValue
      }
    },
    adminAmount: {
      get: function () {
        return (this.formData.transaction_fees * (this.formData.loanableAmount)) * (this.tenor / 365)
      },
      set: function (newValue) {
        this.formData.adminAmount = newValue
      }
    }
  },
  watch: {},
  async mounted () {
    this.$nextTick(() => {
      this.loadData()
    })
  },
  methods: {
    ...mapActions('invoice', [
      'fetchInvoice',
      'SingleInvoiceArray'
    ]),
    ...mapActions('prepayment', [
      'fetchCreatePayment',
      'addPayment',
      'updatePayment',
      'fetchEditPaymentData',
      'createPrepaymentRequest',
      'addPrepaymentRequest',
      'editPrepaymentRequest',
      'updatePrepaymentRequest'
    ]),
    ...mapActions('modal', [
      'openModal'
    ]),
    ...mapActions('LoanRequest', [
      'loanRequestStatus'
    ]),
    ...mapActions('companyImpactOthers', [
      'addCompanyImpactOthers',
      'getImpact'
    ]),
    async loadInvoice () {
      let response = await this.SingleInvoiceArray(this.$route.params.id)
      if (response.data) {
        this.fetchData = response.data.invoice
      }
    },
    round (value, decimals) {
      return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals)
    },
    // a and b are javascript Date objects
    dateDiffInDays (a, b) {
      const _MS_PER_DAY = 1000 * 60 * 60 * 24
      // Discard the time and time-zone information.
      let utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate())
      let utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate())
      return Math.floor((utc2 - utc1) / _MS_PER_DAY)
    },
    async loadData () {
      if (moment.tz(moment(new Date(Date.now())), 'Asia/Karachi').format('HH:mm:ss') > '18:00:00') {
        this.formData.offer_expire = moment(new Date(Date.now() + 1 * 24 * 60 * 60 * 1000)).toString()
      } else {
        this.formData.offer_expire = moment(new Date(Date.now())).toString()
      }
      let response = await this.editPrepaymentRequest(this.$route.params.id)
      this.formData.supplier_comment = response.data.prepaymentRequest.supplier_comment
      this.formData.superAdmin_comment = response.data.prepaymentRequest.superAdmin_comment
      this.formData.anchor_comment = response.data.prepaymentRequest.superAdmin_comment
      this.formData.supplier_offer_request = response.data.prepaymentRequest.supplier_offer_request
      this.formData.formattedSupplierOfferRequestDate = response.data.prepaymentRequest.formattedSupplierOfferRequestDate

      this.customerCurrency = response.data.prepaymentRequest.invoice.customer.currency

      this.formData.payment_date = moment(response.data.prepaymentRequest.prepayment_date, 'YYYY-MM-DD').toString()
      if (this.userType === 'funder') {
        if (this.$route.name === 'preapproved.invoice.pending') {
          this.formData.promised_payment_date = moment(response.data.prepaymentRequest.invoice.due_date, 'YYYY-MM-DD').toString()
          // test it
          var date1 = new Date(Date())
          // var date2 = new Date(response.data.prepaymentRequest.promised_payment_date)
          var date2 = new Date(response.data.prepaymentRequest.invoice.due_date)
          this.tenor = this.dateDiffInDays(date1, date2)
        } else {
          this.formData.promised_payment_date = moment(response.data.prepaymentRequest.promised_payment_date, 'YYYY-MM-DD').toString()
          var date1 = new Date(Date())
          var date2 = new Date(response.data.prepaymentRequest.promised_payment_date)
          this.tenor = this.dateDiffInDays(date1, date2)
        }
      }
      this.formData.requested_amount = response.data.prepaymentRequest.requested_amount
      this.maxPayableAmount = response.data.prepaymentRequest.requested_amount / 100

      this.requestNumber = response.data.request_prefix + '-' + response.data.nextRequestNumber
      this.formData.payment_method = response.data.prepaymentRequest.payment_method

      this.formData.invoice_id = response.data.prepaymentRequest.invoice.id

      let taxes = response.data.prepaymentRequest.invoice.taxes
      let addTaxes = null
      let subTaxes = null
      if (taxes) {
        addTaxes = response.data.prepaymentRequest.invoice.taxes.filter(function (obj) {
          return obj.operator !== 'Subtract'
        })
        if (addTaxes.length > 0) {
          this.nomial_amount = response.data.prepaymentRequest.invoice.sub_total +
                                response.data.prepaymentRequest.invoice.taxes.filter(function (obj) {
                                  return obj.operator !== 'Subtract'
                                }).map(o => o.amount).reduce((a, c) => { return a + c })
        } else {
          this.nomial_amount = response.data.prepaymentRequest.invoice.sub_total
        }

        subTaxes = response.data.prepaymentRequest.invoice.taxes.filter(function (obj) {
          return obj.operator == 'Subtract'
        })
        if (subTaxes.length > 0) {
          this.formData.withholding_tax_rate = (response.data.prepaymentRequest.invoice.taxes.filter(function (obj) {
            return obj.operator == 'Subtract'
          }).map(o => o.amount).reduce((a, c) => { return a + c })) / 100
        }
      }
      this.formData.user_id = response.data.prepaymentRequest.invoice.user_id
      this.formData.user_company_id = response.data.prepaymentRequest.invoice.company_id
      this.formData.customer_id = response.data.prepaymentRequest.invoice.customer_id
      this.cashflowValue = response.data.prepaymentRequest.requested_amount
      this.getRateOfPrepayment()
      return true
    },
    async getRateOfPrepayment () {
      let data = {
        company_id: localStorage.getItem('selectedCompany'),
        guest_company_id: this.formData.user_company_id
      }
      let response = await this.getImpact(data)
      if (response.data && response.data.margin_rate) {
        this.formData.margin_rate = response.data.margin_rate
      }
      if (response.data && response.data.rate_of_prepayment) {
        this.formData.rate_of_prepayment = Number(response.data.rate_of_prepayment)
      }
      if (response.data && response.data.transaction_fees) {
        this.formData.transaction_fees = response.data.transaction_fees
      }
    },
    async cashFlowModel () {
      this.openModal({
        'title': 'CashFlow Value of Invoice',
        'componentName': 'CashFlowValueInvoiceModal',
        'data': {
          'invoiceTotal': this.nomial_amount,
          'withholding_tax_rate': this.formData.withholding_tax_rate,
          'currency': this.customerCurrency
        }
      })
    },
    async offerAmountModel () {
      this.openModal({
        'title': 'Offer Amount',
        'componentName': 'OfferAmountModal',
        'data': {
          'laonAmount': this.formData.loanableAmount,
          'discount': this.formData.discount,
          'adminFee': this.formData.adminAmount
        }
      })
    },
    async submitPaymentData () {
      this.$v.formData.$touch()
      if (this.$v.$invalid) {
        return true
      }
      let data = {
        id: this.$route.params.id,
        amount: this.formData.amount,
        rate_of_prepayment: this.formData.rate_of_prepayment,
        margin_rate: this.formData.margin_rate,
        transaction_fees: this.formData.transaction_fees,
        offer_expire: this.formData.offer_expire ? moment(this.formData.offer_expire).format('DD/MM/YYYY') : null
      }
      swal({
        title: this.$t('general.are_you_sure'),
        text: this.$tc('invoices.send_offer'),
        icon: '/assets/icon/paper-plane-solid.svg',
        buttons: true,
        dangerMode: true
      }).then(async (value) => {
        if (value) {
          this.isLoading = true
          this.isRejectedButtonShow = false
          let response = await this.updatePrepaymentRequest(data)
          if (response.data.success) {
            if (this.userType === 'funder') {
              const SuperAdminData = {
                invoice_id: this.$route.params.id,
                request_level: 'Offered'
              }
              let res = await this.loanRequestStatus(SuperAdminData)
              if (res.data.success) {
              }
              this.isLoading = false

              if (this.$route.name === 'preapproved.invoice.pending') {
                this.$router.push('/funder/preapproved-invoices')
              } else {
                this.$router.push('/funder/invoices')
              }
            }
            window.toastr['success'](this.$t('prepayments.prepayment_updated_message'))
            return true
          }
        }
      })
    },
    async rejectedPrepaymentRequest () {
      const data = {
        invoice_id: this.formData.invoice_id,
        request_level: 'Rejected'
      }
      this.isLoading = true
      this.isOfferButtonShow = false
      let response = await this.loanRequestStatus(data)
      if (response.data.success) {
        if (this.userType === 'funder') {
          if (this.$route.name === 'preapproved.invoice.pending') {
            this.$router.push('/funder/preapproved-invoices')
          } else {
            this.$router.push('/funder/invoices')
          }
        }
        window.toastr['success'](this.$tc('prepayments.prepayment_rejected_message'))
        return true
      }
    }
  }
}
</script>
<style scoped>
.table-component{
  min-height: 0px;
}
</style>
